import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

const LoginView: React.FC = () => {
  const { signIn, isLoading, error, clearError } = useAuthStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    await signIn(email.trim(), password);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{ backgroundColor: '#171a1f' }}
    >
      <div
        className="w-full max-w-sm rounded-lg p-6 shadow-2xl"
        style={{ backgroundColor: '#20242b', border: '1px solid #343a43' }}
      >
        <div className="mb-6 text-center">
          <h1 className="text-lg font-semibold text-white">NetBuilder Pro</h1>
          <p className="text-xs mt-1" style={{ color: '#9ca3af' }}>
            Sign in to continue
          </p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <div>
            <label className="block text-[11px] uppercase tracking-wide font-medium mb-1" style={{ color: '#9ca3af' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full text-sm px-3 py-2 rounded border focus:outline-none focus:ring-1 focus:ring-blue-500"
              style={{ backgroundColor: '#171a1f', borderColor: '#343a43', color: '#e5e7eb' }}
              placeholder="you@example.com"
            />
          </div>

          <div>
            <label className="block text-[11px] uppercase tracking-wide font-medium mb-1" style={{ color: '#9ca3af' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className="w-full text-sm px-3 py-2 rounded border focus:outline-none focus:ring-1 focus:ring-blue-500"
              style={{ backgroundColor: '#171a1f', borderColor: '#343a43', color: '#e5e7eb' }}
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p className="text-xs px-2 py-1.5 rounded" style={{ color: '#fca5a5', backgroundColor: 'rgba(127,29,29,0.3)' }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={isLoading || !email.trim() || !password}
            className="mt-1 w-full flex items-center justify-center gap-2 text-sm font-medium py-2 rounded transition-colors disabled:opacity-50"
            style={{ backgroundColor: '#2563eb', color: '#fff' }}
          >
            {isLoading && <Loader2 size={14} className="animate-spin" />}
            Sign in
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginView;
